exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tabbarHeaderInner[data-v-a56e9748] {\n  height: 100%;\n}\n.tabbarHeaderInner .tabbarItem[data-v-a56e9748] {\n  height: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.tabbarHeaderInner .tabbarItem .iconStyle[data-v-a56e9748] {\n  color: #8f8f8f;\n  font-size: 26px;\n}\n.tabbarHeaderInner .tabbarItem .countText[data-v-a56e9748] {\n  color: #8f8f8f;\n  font-size: 12px;\n  padding-left: 3px;\n}\n", ""]);

// exports
